import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import docAid from "../../assets/dentist.png";

// Helper to get all users (default + stored)
const getAllUsers = () => {
  const defaultUsers = [
    { email: "admin@gmail.com", password: "123456", role: "admin" },
    { email: "doctor@gmail.com", password: "123456", role: "doctor" },
    { email: "patient@gmail.com", password: "123456", role: "patient" },
  ];
  const stored = JSON.parse(localStorage.getItem("users")) || [];
  return [...defaultUsers, ...stored];
};

const RegenerateOTP = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    // Get all users
    const users = getAllUsers();
    const userExists = users.some((u) => u.email === email);

    if (!userExists) {
      toast.error("Email not registered. Please sign up first.");
      setLoading(false);
      return;
    }

    // Generate OTP
    const otp = Math.floor(1000 + Math.random() * 9000);

    // Store OTP with email (for validation)
    localStorage.setItem(
      "userOTP",
      JSON.stringify({
        email: email,
        otp: otp,
        timestamp: Date.now(), // optional: for expiry
      })
    );

    toast.success(`OTP sent to ${email} (Demo: ${otp})`);
    setLoading(false);

    // Navigate to OTP validation page
    navigate("/validateOTP");
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center px-4">
      <div className="max-w-5xl w-full bg-white rounded-2xl shadow-xl overflow-hidden flex flex-col lg:flex-row">
        {/* Image */}
        <div className="lg:w-1/2 flex justify-center items-center p-10">
          <img src={docAid} alt="doctor" className="w-[350px]" />
        </div>

        {/* Form */}
        <div
          className="lg:w-1/2 p-10 flex items-center"
          style={{ backgroundColor: "rgb(237,231,242)" }}
        >
          <form onSubmit={handleSubmit} className="w-full">
            <h1 className="text-3xl font-bold text-center mb-4">
              Regenerate OTP
            </h1>
            <p className="text-center text-gray-600 mb-8">
              Enter your registered email address
            </p>

            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter Email"
              className="w-full px-6 py-4 rounded-xl border focus:outline-none focus:ring-2 focus:ring-teal-400"
            />

            <button
              type="submit"
              disabled={loading}
              className="mt-6 w-full py-4 rounded-xl text-white font-semibold disabled:opacity-50 transition"
              style={{ backgroundColor: "rgb(7,160,165)" }}
            >
              {loading ? "Sending..." : "Send OTP"}
            </button>

            <div className="text-center mt-4">
              <span
                className="text-sm text-blue-500 cursor-pointer hover:underline"
                onClick={() => navigate("/login")}
              >
                Back to Login
              </span>
            </div>
          </form>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default RegenerateOTP;